import type { LinariaClassName } from '@linaria/core'
import { memo } from 'react'
import IconButton from '../../../Buttons/IconButton'
import NotesIcon from '../../../Icons/Notes'
import Container from '../Container'

interface NotesButtonProps {
    className?: LinariaClassName
    shadow?: boolean
    title?: string
    color?: string
    size?: number
    filled?: boolean
    tooltipPlacement?: 'top' | 'bottom'
    onClick?: any
}

const NotesButton = memo((props: NotesButtonProps) => {
    const {
        title,
        color,
        size,
        filled,
        shadow,
        tooltipPlacement,
        onClick,
        className,
    } = props
    return (
        <Container
            tooltipPlacement={tooltipPlacement}
            shadow={shadow}
            title={title}
        >
            <IconButton
                data-testid="Container__NotesButton"
                className={className}
                onClick={onClick}
            >
                <NotesIcon
                    color={color ?? '#fff'}
                    size={size}
                    filled={filled}
                />
            </IconButton>
        </Container>
    )
})

export default NotesButton
